/* 2026-09-03: ForMommy and Mushroom Plenty are retired, so every page is the
   electronics brand world. The old URL / product-JSON / fetch detection
   always resolved to this class anyway; kept as a file so existing
   theme.liquid references keep working. */
document.body.classList.add('brand-electronics');
